<template>
    <div >
        <!-- <img id='img' class="img-pdf" /> -->
        <iframe id="frame3d" src="http://localhost:44353//UploadDown/Temporary/30902318-7c2e-4e89-9c00-344a9828d466/LYS190619KG111.pdf" scrolling="auto" width="100%" style="width:100%;height:100%;"></iframe>
        <div class="download">
            <!-- <div class="download-btn" @click="download"  download="filename">下载下载</div>  -->
            <a class="download-btn" href="http://localhost:44353//UploadDown/Temporary/30902318-7c2e-4e89-9c00-344a9828d466/LYS190619KG111.pdf" download="files/">下载下载</a>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            reportData:[],
        }
    },
    
    mounted(){
        // this.reportData=JSON.parse(sessionStorage.getItem('ReportData'));
        // if (!this.reportData || !(this.reportData.Id > 0)) {
        
        //     alert("无数据");
        //     this.closeWindow();
        // }
        // if(!this.reportData.ImageUrl){
		//     this.reportData.ImageUrl = this.reportData.PdfUrl.replace('.pdf', '.jpg')
        // }
        // $('#img').attr('src', process.env.BASE_URL + '/' + this.reportData.ImageUrl);
       this.resize()
        
    },
    methods:{
        closeWindow() {
            var userAgent = navigator.userAgent;
            if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") != -1) {
                window.location.href = "about:blank";
                window.close();
            } else {
                window.opener = null;
                window.open("", "_self");
                window.close();
            }
        },
        resize(){
             var height = $(window).height();
             $('#frame3d').height(height);
            
        },
        download(){
            alert('下载了');
            var urls="http://localhost:44353//UploadDown/Temporary/30902318-7c2e-4e89-9c00-344a9828d466/LYS190619KG111.pdf";
            window.open(urls,'_blank');
        }
    }
}
</script>

<style lang="scss" scoped>
html{
    height: 100% !important;
    width: 100% !important;
    overflow: hidden !important;
}
.report-body{
    width:100%;
    height: 100%;
}
.img-pdf{
    width:100%;
    height: 100%;
}
.download{
    z-index:10000;
    position:fixed;
    left:20rem;
    top:20rem;
    .download-btn{
        width:120px;
        height: 60px;
        border-radius: 50%;
        background:#fff;
        color:#fe0000;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/reportresultimg.vue